import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class CategoryItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultName: this.props.category.guide_category_name,
      defaultImageUrl: this.props.category.image,
      guide_category_name: this.props.category.guide_category_name,
      image_url: this.props.category.image,
      img: '',
      image_error: ''
    }
  }

  _handleEditClick (e) {
    this.setState({ edit: true })
    e.stopPropagation()
  }
  _handleDeleteClick (e) {
    console.log('delete category id: ', this.props.category.id)
    e.stopPropagation()
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.category.id)
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      image_url: this.state.defaultImageUrl,
      image: '',
      image_error: ''
    })
  }
  _handleSaveClick () {
    console.log('saving data...')
    const {
      guide_category_name,
      image
    } = this.state
    const data = {
      guide_category_id: this.props.category.id,
      guide_category_name
    }
    this.props.saveData(data, image)
    this.setState({ edit: false })
  }

  _handleCategoryClick () {
    if (!this.state.edit) {
      this.props.history.push(`/properties/${this.props.propertyID}/guides/${this.props.category.id}`)
    }
  }
  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById(`image_${this.props.category.id}`).value = ''
  }

  _renderImageLabel () {
    if (this.state.edit) {
      if (this.state.image_url) {
        return (
          <div className="label_container">
            <label className="image_input_label image_selected" htmlFor={`image_${this.props.category.id}`}>
              <img className="img-responsive" src={this.state.image_url} alt=""/>
            </label>
            <div className="delete_container" onClick={this._resetImage.bind(this)}>
              <span></span>
              <span></span>
            </div>
          </div>
        )
      }
      return (
        <div className="label_container">
          <label className="image_input_label image_blank" htmlFor={`image_${this.props.category.id}`}>
            <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </label>
        </div>
      )
    }
    return (
      <div className="label_container">
        <div className="image_input_label image_selected show" htmlFor={`image_${this.props.category.id}`}>
          <img className="img-responsive" src={this.state.image_url} alt=""/>
        </div>
      </div>
    )
  }

  _renderRightBlock () {
    if (this.state.edit) {
      return (
        <div className="right_block">
          <div className="input_group">
            <label htmlFor="name">件名</label>
            <input type="text" value={ this.state.guide_category_name } onChange={ this._handleUpdateContent.bind(this, 'guide_category_name') }/>
          </div>
          <div className="input_group">
            <label htmlFor="tel">メニュ一覧</label>
            <div className="value" >{ this.props.category.item_count }</div>
          </div>
          <div className="input_group">
            <label htmlFor="open">更新日時</label>
            <div className="value" >{ this.props.category.update_date }</div>
          </div>
        </div>
      )
    }
    return (
      <div className="right_block">
        <div className="input_group">
          <label htmlFor="name">件名</label>
          <div className="value" >{ this.state.guide_category_name }</div>
        </div>
        <div className="input_group">
          <label htmlFor="tel">メニュ一覧</label>
          <div className="value" >{ this.props.category.item_count }</div>
        </div>
        <div className="input_group">
          <label htmlFor="open">更新日時</label>
          <div className="value" >{ this.props.category.update_date }</div>
        </div>
      </div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="categories" onClick={this._handleCategoryClick.bind(this)}>
        <div className="info_inner admin_inner flex justify-between">
          <div className="input-group flex column">
            <label className="label text-center" htmlFor="image">
              {
                this.state.edit
                  ? <span className="smallest file_requirements">（JPEG・PNGファイルのみ）</span>
                  : null
              }

            </label>
            <div className="image_input_container flex">
              { this._renderImageLabel() }
              <div>
                <div className="image_error small">{ this.state.image_error }</div>
                <input
                  type="file"
                  id={`image_${this.props.category.id}`}
                  onChange={this._handleImageChange.bind(this)}
                />
              </div>
            </div>
          </div>

          <div className="contents flex top_label">
            { this._renderRightBlock()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default withRouter(CategoryItem)



// WEBPACK FOOTER //
// ./src/components/Properties/Guides/CategoryItem.js